import { IAnalyticsEvent } from '@verv-inc/js-toolkit';

export const VervBIEvent = {
	showPayment: (): IAnalyticsEvent => ({ name: 'show_checkout' }),
	showPaywall: (): IAnalyticsEvent => ({ name: 'show_tariff' }),
	startQuiz: (): IAnalyticsEvent => ({ name: 'start_quiz' }),
	endQuiz: (): IAnalyticsEvent => ({ name: 'end_quiz' }),
};
